import axios from "axios";
import Config from "../Config";

export default {
  // 통합 소셜 계정 토큰 쿠키로 로그인 후 로컬 계정 추천 리스트를 조회
  getLocalAccountList(serviceId, param, config) {
    const url = `${Config.API_DOMAIN}/etoos/members/v1/transfer/get/id/list/${serviceId}/auth`;
    return axios.post(url, param, config);
  },
  // 통합회원 전환 계정 목록 조회 (로그인으로 접근시 사용)
  getTransferAccountIntegrate(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/transfer/service/get/id/list`;
    return axios.post(url, param, config);
  },
  // 서비스 전환 계정 목록 조회 (회원가입으로 접근시 사용)
  getTransferAccountService(serviceId, param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/transfer/get/id/list/${serviceId}`;
    return axios.post(url, param, config);
  },
  // 전환 회원 생일 조회
  getTransferUserBirth(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/transfer/get/birth";
    return axios.post(url, param, config);
  },
  // 전환 약관 동의 API
  insertTransferTerm(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/transfer/terms";
    return axios.post(url, param, config);
  },
  // 전환 통합 회원가입 API
  insertTransferIntegratedRegister(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/transfer/registration";
    return axios.post(url, param, config);
  },
  // 전환 통합 SNS 회원가입 API
  insertTransferIntegratedSocialRegister(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/transfer/registration/sns";
    return axios.post(url, param, config);
  },
  //전환처리요청 API
  transferAccount(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/transfer/account`;
    return axios.post(url, param, config);
  }
};
